import React, { useCallback, useMemo, useState } from 'react'
import { makeStyles } from '@material-ui/styles'
import GrinFloatingPopup from 'components/common/menu/GrinFloatingPopup'
import { useDispatch, useSelector } from 'react-redux'
import { Pinned } from 'components/common/icons'
import PinnedNotesFloatingPopupContent from './PinnedNotesV1/PinnedNotesFloatingPopupContent'
import { useTranslation } from 'react-i18next'
import { trackEvent } from 'utils/analyticsUtils'
import Actions from 'actions'
import { PATIENT_CARD_TABS } from 'consts/patientCard'
import usePatientNotes from 'hooks/RTK/usePatientNotes'
import useFeatureFlags from 'hooks/useFeatureFlags'
import PinnedNotesTriggerButton from './PinnedNotesTriggerButton'
import useSelectPatientView from 'components/Patients/PatientSwitchableView/useSelectPatientView'
import { PatientSidebarItemKeys } from 'components/Patients/PatientSwitchableView/PatientSidebar/patientSidebarConsts'

const useStyles = makeStyles(theme => ({
  container: {
    padding: '10px 10px 0 10px'
  },
  title: {
    fontSize: 13,
    fontWeight: 600,
    color: '#727B8C',
    cursor: 'pointer'
  },
  pinnedIcon: {
    paddingTop: 4
  }
}))

const PinnedNotes = () => {
  const classes = useStyles()
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { grinDesignRefresh: grinDesignRefreshFF } = useFeatureFlags()
  const { selectPatientView } = useSelectPatientView()

  const { id: patientId } = useSelector(state => state.patientsReducer.patient)
  const { notes } = usePatientNotes()
  const pinnedNotes = useMemo(() => notes?.filter(note => note?.isPinned), [notes])
  const hasPinnedAnyNotes = useMemo(() => pinnedNotes?.length > 0, [pinnedNotes])

  const [tooltipOpen, setTooltipOpen] = useState(false)

  const handleClose = useCallback(() => setTooltipOpen(false), [])
  const handleOpenPatientCard = useCallback(() => {
    trackEvent('Pinned notes - open patient card notes tab')
    setTooltipOpen(false)

    if (grinDesignRefreshFF) {
      selectPatientView(PatientSidebarItemKeys.Notes)
    } else {
      dispatch(
        Actions.togglePatientCard({
          isModalOpen: true,
          patientId,
          selectedTab: PATIENT_CARD_TABS.notes.index
        })
      )
    }
  }, [dispatch, selectPatientView, patientId, grinDesignRefreshFF])

  return (
    hasPinnedAnyNotes && (
      <div onMouseOver={() => setTooltipOpen(true)} onMouseLeave={handleClose}>
        <GrinFloatingPopup
          title={t('pages.patients.selectedPatient.header.pinnedNotes.title')}
          titleId="patient-header-pinned-notes-title"
          titleIcon={<Pinned color="var(--text-color-11)" className={classes.pinnedIcon} />}
          titleClassName={classes.title}
          onTitleClick={handleOpenPatientCard}
          placement="right-start"
          containerClassName={classes.container}
          triggerComponent={<PinnedNotesTriggerButton count={pinnedNotes.length} />}
          open={tooltipOpen}
          withCloseIcon={false}
        >
          <PinnedNotesFloatingPopupContent notes={pinnedNotes} />
        </GrinFloatingPopup>
      </div>
    )
  )
}

export default PinnedNotes
